import { render, staticRenderFns } from "./giftCardOrderList.vue?vue&type=template&id=75033618&scoped=true"
import script from "./giftCardOrderList.vue?vue&type=script&lang=js"
export * from "./giftCardOrderList.vue?vue&type=script&lang=js"
import style0 from "./giftCardOrderList.vue?vue&type=style&index=0&id=75033618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75033618",
  null
  
)

export default component.exports